module.exports = __webpack_public_path__ + "5988b3bed000535d4ee8e4c5de8097c4.fbx";